import { EXPORTS_FOLDER_NAME } from 'common/constants/documents';

type SortableDocumentFolder = {
  name: string;
};

const EXPORTS_FOLDER_SORT_VALUES = new Set([
  EXPORTS_FOLDER_NAME.toLowerCase(),
  EXPORTS_FOLDER_NAME.toLowerCase().replace(/s$/, ''),
]);

const getDocumentFolderNameSortValue = (folder: SortableDocumentFolder) =>
  folder.name.trim().toLowerCase();

export const isExportsDocumentFolder = (folder: SortableDocumentFolder) =>
  EXPORTS_FOLDER_SORT_VALUES.has(getDocumentFolderNameSortValue(folder));

export const compareDocumentFoldersForDisplay = (
  folderA: SortableDocumentFolder,
  folderB: SortableDocumentFolder
) => {
  const isFolderAExports = isExportsDocumentFolder(folderA);
  const isFolderBExports = isExportsDocumentFolder(folderB);

  if (isFolderAExports !== isFolderBExports) {
    return isFolderAExports ? 1 : -1;
  }

  return folderA.name.localeCompare(folderB.name, undefined, { sensitivity: 'base' });
};

export const orderDocumentFoldersForDisplay = <TFolder extends SortableDocumentFolder>(folders: TFolder[]) =>
  [...folders].sort(compareDocumentFoldersForDisplay);
